export const REQUIRED_FIELDS = ['finDocType', 'reportType', 'sourceType'] as const;
export const FIELDS_NAMES = {
    finDocType: 'Financial Document Type',
    reportType: 'Report Format Type',
    sourceType: 'Source Type',
} as const;
export const MODE = { SINGLE_PAGE: 'SINGLE_PAGE', MULTI_PAGE: 'MULTI_PAGE' } as const;
/**
 * number of pages to be shown before and after the currently selected page
 */
export const SINGLE_PAGE_VIEW_CONTEXT = 1;
